import classnames from 'classnames';
import React from 'react';
import { TextSkeleton, ImageSkeleton } from '@udemy/react-reveal-components';
import styles from "./hero-banner-skeleton.module.css";
export const HeroBannerSkeleton = ({
  limitHeight = false
}) => {
  return /*#__PURE__*/React.createElement("section", {
    className: classnames(styles.wrapper, {
      [styles['wrapper-limited-size']]: limitHeight
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles['content-container'], {
      [styles['content-container-y-centered']]: limitHeight,
      [styles['content-container-with-margin']]: !limitHeight
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['heading-container']
  }, /*#__PURE__*/React.createElement(TextSkeleton, {
    withTitle: true,
    lineCountPerParagraph: 9
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['image-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles['image-block'], styles['image-block-aspect-ratio'], {
      [styles['image-block-remove-aspect-ratio']]: limitHeight,
      [styles['image-block-limited-size']]: limitHeight
    })
  }, /*#__PURE__*/React.createElement(ImageSkeleton, null))));
};
//# sourceMappingURL=hero-banner-skeleton.react-component.js.map